import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import * as builder from '../../ducks/builder';

const StatusBadge = ({ domainName, hideText, size, fromLoginPage }) => {
  const imgSize = size === 'mobile' ? '24px' : '18px';
  const statusUrl = useMemo(() => getStatusUrl(domainName), [domainName]);

  useEffect(() => {
    if (!statusUrl) {
      return;
    }
    const scriptSrc = `${statusUrl}/script.js`;
    const existing = document.querySelector(`script[src="${scriptSrc}"]`);
    if (existing) {
      if (existing.getAttribute('data-polling-interval') === '60000') {
        return;
      }
      existing.parentNode.removeChild(existing);
    }
    const script = document.createElement('script');
    script.src = scriptSrc;
    script.defer = true;
    script.async = true;
    script.setAttribute('data-polling-interval', '60000');
    document.body.appendChild(script);
  }, [statusUrl]);

  if (!statusUrl) {
    return null;
  }

  return (
    <a
      href={statusUrl}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}
    >
      <span
        style={{ padding: '0 10px', display: 'flex', alignItems: 'center' }}
      >
        <img
          src={`${statusUrl}/badge.svg`}
          width={imgSize}
          height={imgSize}
          alt="Status badge"
          style={{ marginRight: hideText ? 0 : '6px' }}
        />
        {!hideText && (
          <span
            style={{
              color: '#74788d',
              fontSize: '1rem',
              display: 'inline'
            }}
            className={fromLoginPage ? undefined : 'status-badge__text'}
          >
            Driftstatus
          </span>
        )}
      </span>
    </a>
  );
};

const mapStateToProps = store => ({
  domainName: builder.selectors.getDomainName(store)
});

export default connect(mapStateToProps)(StatusBadge);

const DSTNY_PROD_DOMAIN = 'dstny.dk';
const DSTNY_STAGE_HOSTNAME = 'mydstny-uat';

const getStatusUrl = hostname => {
  if (!hostname) {
    return null;
  }

  if (hostname.includes('localhost')) {
    return 'https://test-status.dstny.dk';
  }
  if (hostname.includes(DSTNY_PROD_DOMAIN)) {
    if (hostname.includes(DSTNY_STAGE_HOSTNAME)) {
      return 'https://test-status.dstny.dk';
    }
    return 'https://status.dstny.dk';
  }

  return 'https://status.partner.dstny.dk';
};
